<!-- 课程详情-文章 -->
<template>
  <div class="article-course-page" id="ArticleCourseDetails">
    <div v-show="isLoading" class="loading">
      <div class="loading-box">
        <van-loading size="24px" vertical color="#f77a3c">加载中...</van-loading>
      </div>
    </div>
    <div class="content">
      <div class="head flex flex-center" v-if="!userInfo.isApp">
        <div class="flex flex-center">
          <img src="../../assets/images/icon2@2x.png" class="haed-icon" alt="" />
          <span>丰云农服APP</span>
        </div>
        <div class="head-open" @click="openApp">打开app</div>
      </div>
      <!-- <div class="header relative">
        <p class="fontsize-18 c262833 fontBold">课程详情</p>
        <div class="sharing absolute" v-if="!iswx">
          <img src="../../assets/images/zhuanfabaise@2x.png" alt="" @click="handelShare"/>
        </div>
      </div> -->
      <div class="cts">
        <div class="title text-left">
          <p class="fontsize-24 c262833">
            {{ infoData.courseName }}
          </p>
        </div>

        <div class="sub-title flex">
          <p class="name fontsize-14 c5F6066">{{ infoData.authorName }}</p>
          <p class="fontsize-12 c91929B">{{ infoData.lastModifiedDate }}</p>
        </div>

        <div class="content word-wrap"  v-html="infoData.courseText ? infoData.courseText : ''"></div>
      </div>
      <!-- 在app上打开 -->
      <div class="open-app" @click="openApp" v-if="!userInfo.isApp">
        <img src="../../assets/images/logo@2x.png" class="app-icon" alt="" />
        <span>APP内打开</span>
      </div>
      <div style="height: 80px"></div>
      <div class="foot">
        <span class="c91929B fontsize-12">{{ infoData.views || 0 }}浏览量</span>
        <div class="flex flex-center">
          <template v-if="userInfo.isApp">
            <img src="../../assets/images/dianzan1@2x.png" class="icons" alt="" v-if="infoData.liked"
              @click="changeLike(infoData.liked)" />
            <img src="../../assets/images/dianzan@2x.png" class="icon" alt="" v-else
              @click="changeLike(infoData.liked)" />
          </template>
          <span>{{ infoData.likes || 0 }}赞</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getUserMethods from "utils/getUserMethods";
import { wexinShare } from "mixins/weixin.js";
import { Toast, Loading } from "vant";
import { formatDate, getText, isWeiXin, openApp } from "utils/mUtils";
import { mapState } from "vuex";
export default {
  mixins: [getUserMethods], // mixins混入策略
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, // 实时屏幕高度
      api_course_info: "/course/info", // 课程详情
      api_course_like: "/course/like", // 课程点赞
      api_course_unlike: "/course/unlike", // 课程取消点赞
      infoData: {},
      id: "",
      loading: false,
      openApp,
      shareText: '', // 课程详情描述
      isLoading: true, // 全局loading加载层
    };
  },
  components: {
    "van-loading": Loading,
  },
  watch: {
    userInfo: {
      handler(newVal) {
        // alert(JSON.stringify(newVal))
        if(newVal.isApp) {
          this.isLoading = false;
        };
      },
      deep: true,
      immediate: true,
    }, 
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    defalutImage() {
      return this.infoData.picUrl ? this.infoData.picUrl : process.env.VUE_APP_AA + require('@/assets/images/default_image.png')
    },
    iswx() {
      return isWeiXin();
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
    if(!this.userInfo.isApp) {
      setTimeout(() => {
        this.isLoading = false;
      },1000);
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // 浏览器高度
    document.getElementById("ArticleCourseDetails").style.height =
      this.windowHeight + "px";
  },
  methods: {
    // 获取详情
    getDetail() {
      let params = {
        courseId: this.id,
      };
      this.$axios.get(this.api_course_info, params).then((res) => {
        if (res.data) {
          res.data.lastModifiedDate = formatDate(res.data.lastModifiedDate);
          this.infoData = res.data;
          this.shareText = getText(this.infoData.courseText).slice(0, 30);
          this.iswx && this.weChatSharing()
        }
      });
    },
    /**
      * 微信分享
      */
    weChatSharing() {
      //请求微信配置参数接口（获取签名），由后台给接口给
      const url = window.location.href.split("#")[0];
      const invitUrl = `${url}#/article-course-details?access_token=${this.getUserData().access_token}&id=${this.id}`;
      this.$axios
        .get("/wechat/jsSign", {
          url,
        })
        .then((res) => {
          if (+res.status == 200) {
            //微信加签
            var obj = {
              appId: res.data.appid,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              timestamp: res.data.timestamp,
            };
            let shareData = {
              title: this.infoData.courseName ? this.infoData.courseName.slice(0, 26) : '课程详情', // 分享标题
              desc: this.shareText || '暂无描述',
              link: invitUrl,
              imgUrl: this.defalutImage
            };
            //引用
            wexinShare(obj, shareData);
          } else {
            console.log("获取sdk参数失败");
          }
        });
    },
    /**
     * app 内调用分享
     */
    handelShare() {
      console.log('使用桥链接调用分享')
    },
    /**
     * 点赞
     * @param type 当前点赞状态
     */
    changeLike(type) {
      // 当前点赞状态为点赞，便是取消点赞
      if (this.loading) return
      this.loading = true
      const url = type ? this.api_course_unlike : this.api_course_like
      this.$axios.post(url, { courseId: this.infoData.courseId }).then((res) => {
        if (+res.status === 200) {
          Toast("操作成功");
          this.getDetail()
        }
      }).finally(() => {
        this.loading = false
      });
    }
  },
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.article-course-page {
  background: white;

  .head {
    padding: 0 12px;
    height: 54px;
    font-size: 15px;
    color: #262833;
    justify-content: space-between;
    background: #ffffff;

    border-bottom: 1px solid #dcdee6;

    .haed-icon {
      width: 44px;
      height: 44px;
      flex-shrink: 0;
      margin-right: 16.5px;
    }

    .head-open {
      width: 68px;
      height: 23px;
      text-align: center;
      line-height: 23px;
      color: #ffffff;
      font-size: 12px;
      background: #f77a3c;
      border-radius: 12px;
    }
  }

  .flex-center {
    align-items: center;
  }

  .open-app {
    width: 124px;
    height: 40px;
    background: #f77a3c;
    box-shadow: 0px 1px 5px 0px rgba(247, 122, 60, 0.2);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    position: fixed;
    bottom: 60px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;

    .app-icon {
      width: 28px;
      height: 28px;
      flex-shrink: 0;
      margin-right: 4px;
    }

    color: #ffffff;
  }

  .header {
    padding: 13px 15px;
    width: 100%;
    background: #ffffff;
    box-sizing: border-box;
    position: sticky;
    top: 0;

    .sharing {
      top: 0;
      bottom: 0;
      margin: auto;
      right: 15px;
      z-index: 1;
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .cts {
    padding: 20px;

    .title {}

    .sub-title {
      background: #f7faf9;
      margin: 16px 0;
      padding: 14px 10px 13px 10px;
      justify-content: space-between;
      align-items: center;
    }

    .flex-center {
      align-items: center;
    }
  }

  .foot {
    width: 100%;
    height: 50px;
    border-top: 1px solid #ebedf5;
    background: #ffffff;
    padding: 0 25px 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #262833;
    font-size: 15px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;

    .icon {
      width: 21px;
      // height: 18px;
      flex-shrink: 0;
      margin-right: 15px;
    }

    .icons {
      width: 21px;
      // height: 18px;
      flex-shrink: 0;
      margin-right: 15px;
    }
  }
}
</style>
<style lang="scss">
/* 组件全局css类调整 */
.article-course-page {
  .content {
    p,div {
      text-align: justify;
      //line-break: anywhere; 
      //word-break:break-all;
      font-size: 18px;
      line-height: 30px;
      color: #262833;
    }

    p {
      img {
        padding: 20px 0px;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
